import 'reflect-metadata';
import { Container } from 'inversify';
import { SERVICE_IDENTIFIER } from './service-identifier';
import { BattleServiceImpl } from '@services/BattleServiceImpl';
import { CartridgesServiceImpl } from '@services/CartridgesServiceImpl';
import { DefendersServiceImpl } from '@services/DefendersServiceImpl';
import { EnemiesServiceImpl } from '@services/EnemiesServiceImpl';
import { BonusServiceImpl } from '@services/BonusServiceImpl';
var container = new Container();
container
    .bind(SERVICE_IDENTIFIER.BATTLE_SERVICE)
    .to(BattleServiceImpl);
container
    .bind(SERVICE_IDENTIFIER.CARTRIDGES_SERVICE)
    .to(CartridgesServiceImpl)
    .inSingletonScope();
container
    .bind(SERVICE_IDENTIFIER.DEFENDERS_SERVICE)
    .to(DefendersServiceImpl)
    .inSingletonScope();
container
    .bind(SERVICE_IDENTIFIER.ENEMIES_SERVICE)
    .to(EnemiesServiceImpl)
    .inSingletonScope();
container
    .bind(SERVICE_IDENTIFIER.BONUS_SERVICE)
    .to(BonusServiceImpl);
export { container };
